// src/components/Notification.tsx
import React, { useEffect, useState } from "react";
import { AlertCircle, CheckCircle, XCircle } from "lucide-react";

type NotificationType = "success" | "error" | "info";

interface NotificationProps {
  type: NotificationType;
  message: string;
  duration?: number;
  onClose?: () => void;
}

const Notification: React.FC<NotificationProps> = ({
  type,
  message,
  duration = 3000,
  onClose,
}) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      if (onClose) onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  if (!visible) return null;

  const bgColor =
    type === "success"
      ? "bg-green-100"
      : type === "error"
      ? "bg-red-100"
      : "bg-blue-100";

  const textColor =
    type === "success"
      ? "text-green-800"
      : type === "error"
      ? "text-red-800"
      : "text-blue-800";

  const Icon =
    type === "success" ? CheckCircle : type === "error" ? XCircle : AlertCircle;

  return (
    <div
      className={`fixed top-4 right-4 z-50 ${bgColor} ${textColor} px-4 py-3 rounded-md shadow-md max-w-md flex items-center`}
    >
      <Icon className="h-5 w-5 mr-2" />
      <p>{message}</p>
      <button
        onClick={() => {
          setVisible(false);
          if (onClose) onClose();
        }}
        className="ml-4 text-gray-500 hover:text-gray-700"
      >
        <XCircle className="h-4 w-4" />
      </button>
    </div>
  );
};

export default Notification;
